import { render, staticRenderFns } from "./Yuqingbianhuaqushi.vue?vue&type=template&id=52ca7140&scoped=true&"
import script from "./Yuqingbianhuaqushi.vue?vue&type=script&lang=js&"
export * from "./Yuqingbianhuaqushi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ca7140",
  null
  
)

export default component.exports